module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.4982/img/provider-ctas-blob-1x.png"